var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn",class:{
  'btn-block': _vm.block,
  'btn-loading': _vm.loading
},attrs:{"type":_vm.nativeType,"variant":_vm.variant,"disabled":_vm.loading},on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }